import { FETCH_SEARCH_RESULTS } from '../constants/actionTypes.js';
import * as api from '../api/index.js';

export const getSearchResults = (details) => async (dispatch) => {
  try {
    console.log(details);
    
    const { data } = await api.fetchSearchResults(details);
    console.log(data);
    

    dispatch({ type: FETCH_SEARCH_RESULTS, payload: data });
  } catch (error) {
    console.log(error);
  }
};

